import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Header from "../components/iam/Home/Header";
import CustomErrorBoundary from "../components/iam/Shared/Error/CustomErrorBoundary";
import UserGroup from "../components/iam/UserGroups/UserGroup";

const PrivateRoutes = ({ isAuthenticated, error, setError }) => {
  // Declare a state variable "openSidebar" and a function "setOpenSidebar"
  // using the "useState" hook. Initialize "openSidebar" with "false."
  const [openSidebar, setOpenSidebar] = useState(false);

  // Define a function called "toggleSidebar" that toggles the value of "openSidebar."
  const toggleSidebar = () => {
    setOpenSidebar(!openSidebar);
  };

  // Render the component's content.
  return isAuthenticated && UserGroup ? (
    <>
      <div>
        <Header toggleSidebar={toggleSidebar} openSidebar={openSidebar} />
        <CustomErrorBoundary error={error} setError={setError} />
        {/* Create a div element with class names "mainContainer" and "mainContainerShift"
           based on the "openSidebar" value. */}
        <div
          className={`mainContainer ${openSidebar ? "mainContainerShift" : ""}`}
        >
          <Outlet openSidebar={openSidebar} />
        </div>
      </div>
    </>
  ) : (
    <Navigate to="/auth/login" />
  );
};

export default PrivateRoutes;
